var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { FormRow } from '@gravity-ui/components';
import { dateTime } from '@gravity-ui/date-utils';
import { Button, Flex, Select } from '@gravity-ui/uikit';
import { FormDatePicker, FormSelect } from '@/components/formUi';
import { useNotification } from '@/components/Notify';
import { GameLevel, GameStatus, RequestMode, useGetPlaceSlotsQuery, useGetPlacesQuery, useUpdateGameMutation, } from '@/store/api';
import { useGameWebSocket } from '@/store/gameWebSocket';
import { DATE_SERV_FORMAT } from '@/tools/constants';
import { useRerender } from '@/tools/hooks/useRerender';
import { GridSlots } from '@/views/places/placeSlots/components/GridSlots';
import { CountdownTimer } from './CountdownTimer';
export var GameStep1 = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var placeListGetState = useGetPlacesQuery({});
    var formMethods = useForm({
        defaultValues: props.data,
        mode: 'onChange',
    });
    var handleSubmit = formMethods.handleSubmit, control = formMethods.control, setValue = formMethods.setValue, formState = formMethods.formState;
    var placeId = useWatch({ control: control, name: 'placeId' });
    var date = useWatch({ control: control, name: 'date' });
    var timeStart = useWatch({ control: control, name: 'timeStart' });
    var timeEnd = useWatch({ control: control, name: 'timeEnd' });
    var placeSlotsGetSate = useGetPlaceSlotsQuery({
        id: (_a = placeId === null || placeId === void 0 ? void 0 : placeId[0]) !== null && _a !== void 0 ? _a : '',
        startDate: (_b = date === null || date === void 0 ? void 0 : date.format(DATE_SERV_FORMAT)) !== null && _b !== void 0 ? _b : '',
        stopDate: (_c = date === null || date === void 0 ? void 0 : date.format(DATE_SERV_FORMAT)) !== null && _c !== void 0 ? _c : '',
    });
    var _g = useUpdateGameMutation(), updateGameAction = _g[0], updateGameState = _g[1];
    var showError = useNotification().showError;
    var rerender = useRerender();
    // Черновик уже создан, используем его ID
    var draftId = props.data.id;
    var _h = useState(false), isReserving = _h[0], setIsReserving = _h[1];
    // WebSocket для real-time обновлений
    var _j = useGameWebSocket({
        url: process.env.REACT_APP_WS_URL || 'http://localhost:3000',
        autoConnect: true,
    }), connected = _j.connected, subscribeToPlace = _j.subscribeToPlace, unsubscribeFromPlace = _j.unsubscribeFromPlace, onEvent = _j.onEvent, offEvent = _j.offEvent;
    // Подписка на события площадки
    useEffect(function () {
        var placeIdValue = placeId === null || placeId === void 0 ? void 0 : placeId[0];
        if (connected && placeIdValue) {
            subscribeToPlace(placeIdValue);
        }
        return function () {
            if (placeIdValue) {
                unsubscribeFromPlace(placeIdValue);
            }
        };
    }, [connected, placeId, subscribeToPlace, unsubscribeFromPlace]);
    // Перезапрос слотов при событиях
    useEffect(function () {
        var handleGameEvent = function () {
            placeSlotsGetSate.refetch();
        };
        onEvent('game:reserved', handleGameEvent);
        onEvent('game:released', handleGameEvent);
        onEvent('game:updated', handleGameEvent);
        return function () {
            offEvent('game:reserved', handleGameEvent);
            offEvent('game:released', handleGameEvent);
            offEvent('game:updated', handleGameEvent);
        };
    }, [offEvent, onEvent, placeSlotsGetSate.refetch]);
    var timeChangeHandler = function (slot) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Проверка: слот занят другой игрой?
                    if (slot.gameId && slot.gameId !== props.data.id) {
                        showError({ message: 'Этот слот уже занят другой игрой' });
                        return [2 /*return*/];
                    }
                    // Устанавливаем значения в форму
                    setValue('timeStart', slot.timeStart, {
                        shouldTouch: true,
                        shouldDirty: true,
                    });
                    setValue('timeEnd', slot.timeEnd, {
                        shouldTouch: true,
                        shouldDirty: true,
                    });
                    // Обновляем черновик
                    return [4 /*yield*/, changeTimeSlot(slot)];
                case 1:
                    // Обновляем черновик
                    _a.sent();
                    rerender();
                    return [2 /*return*/];
            }
        });
    }); };
    var currentPlace = (_d = placeListGetState.data) === null || _d === void 0 ? void 0 : _d.items.find(function (el) { return el.id === props.data.placeId[0]; });
    /** Изменение времени в черновике (только update) */
    var changeTimeSlot = function (slot) { return __awaiter(void 0, void 0, void 0, function () {
        var dateValue, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!draftId) {
                        showError({ message: 'Черновик игры не найден' });
                        return [2 /*return*/];
                    }
                    dateValue = date;
                    if (!dateValue) {
                        showError({ message: 'Дата не выбрана' });
                        return [2 /*return*/];
                    }
                    setIsReserving(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateGameAction({
                            id: draftId,
                            updateGameDto: {
                                id: draftId,
                                placeId: props.data.placeId[0],
                                timeStart: slot.timeStart,
                                timeEnd: slot.timeEnd,
                                date: dateValue.format(DATE_SERV_FORMAT),
                                level: ((_a = props.data.level) === null || _a === void 0 ? void 0 : _a[0]) || GameLevel.Easy,
                                requestMode: props.data.requestMode || RequestMode.Private,
                            },
                        }).unwrap()];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    console.error('Ошибка обновления времени:', error_1);
                    showError({
                        message: error_1 && typeof error_1 === 'object' && 'data' in error_1
                            ? ((_b = error_1.data) === null || _b === void 0 ? void 0 : _b.message) ||
                                'Не удалось обновить время'
                            : 'Не удалось обновить время',
                    });
                    // Сбрасываем выбранное время при ошибке
                    setValue('timeStart', undefined);
                    setValue('timeEnd', undefined);
                    return [3 /*break*/, 5];
                case 4:
                    setIsReserving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var submitHandler = function (event) {
        handleSubmit(function (formData) {
            var _a;
            // Валидация: все поля должны быть заполнены
            if (!((_a = formData.placeId) === null || _a === void 0 ? void 0 : _a[0]) ||
                !formData.date ||
                !formData.timeStart ||
                !formData.timeEnd) {
                return;
            }
            var step1Data = {
                placeId: formData.placeId,
                date: formData.date,
                timeStart: formData.timeStart,
                timeEnd: formData.timeEnd,
            };
            props.onNext(step1Data);
        })(event);
    };
    // Проверка валидности данных для активации кнопки "Далее"
    var isStep1Valid = function () {
        var placeIdValue = placeId === null || placeId === void 0 ? void 0 : placeId[0];
        var dateValue = date;
        var timeStartValue = formMethods.getValues('timeStart');
        var timeEndValue = formMethods.getValues('timeEnd');
        return !!(placeIdValue &&
            dateValue &&
            timeStartValue !== undefined &&
            timeEndValue !== undefined &&
            !formState.errors.placeId &&
            !formState.errors.date);
    };
    return (_jsx(_Fragment, { children: _jsxs(Flex, { direction: "column", gap: 4, children: [_jsxs("div", { children: ["\u041F\u043B\u043E\u0449\u0430\u0434\u043A\u0430:", ' ', _jsx("strong", { children: (currentPlace === null || currentPlace === void 0 ? void 0 : currentPlace.name) || props.data.place.name })] }), _jsxs("div", { children: ["\u0414\u0430\u0442\u0430:", ' ', _jsxs("strong", { children: [dateTime({ input: date }).format('LL'), ' ', dateTime({ input: date }).format('dddd')] })] }), _jsxs("div", { children: ["\u0412\u0440\u0435\u043C\u044F:", ' ', _jsx("strong", { children: timeStart !== undefined ? (_jsxs(_Fragment, { children: [String(Math.floor(timeStart / 60)).padStart(2, '0'), ":", String(timeStart % 60).padStart(2, '0'), " -", ' ', String(Math.floor(timeEnd / 60)).padStart(2, '0'), ":", String(timeEnd % 60).padStart(2, '0')] })) : ('Не выбрано') })] }), _jsxs("div", { children: ["\u0421\u043E\u0437\u0434\u0430\u043D\u0430:", ' ', _jsx("strong", { children: dateTime({ input: props.data.createdAt }).format('LLL') })] }), _jsxs("div", { children: ["\u0421\u0442\u0430\u0442\u0443\u0441: ", _jsx("strong", { children: props.data.status })] }), props.data.status === GameStatus.Draft && (_jsx(CountdownTimer, { date: props.data.createdAt })), _jsx(FormProvider, __assign({}, formMethods, { children: _jsx("form", { onSubmit: submitHandler, children: _jsxs(Flex, { direction: "column", gap: 4, children: [_jsx(FormRow, { direction: "row", fieldId: "placeId", label: "\u041F\u043B\u043E\u0449\u0430\u0434\u043A\u0430", className: "mod", children: _jsx(FormSelect, { name: "placeId", placeholder: "\u041F\u043B\u043E\u0449\u0430\u0434\u043A\u0430", validationState: formState.errors.placeId ? 'invalid' : undefined, children: (_e = placeListGetState.data) === null || _e === void 0 ? void 0 : _e.items.map(function (el) { return (_jsx(Select.Option, { value: el.id, children: el.name }, el.id)); }) }) }), _jsx(FormRow, { direction: "row", fieldId: "date", label: "\u0414\u0430\u0442\u0430", children: _jsx(FormDatePicker, { name: "date", format: "DD.MM.YYYY", placeholder: "\u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0434\u0430\u0442\u0443", validationState: formState.errors.date ? 'invalid' : undefined }) }), !!(placeId === null || placeId === void 0 ? void 0 : placeId.length) && !!((_f = currentPlace === null || currentPlace === void 0 ? void 0 : currentPlace.sports) === null || _f === void 0 ? void 0 : _f.length) && (_jsx("div", { style: { marginTop: 8, color: '#666', fontSize: 14 }, children: "\u0412\u0438\u0434 \u0441\u043F\u043E\u0440\u0442\u0430 \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u0431\u0440\u0430\u043D \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C \u0448\u0430\u0433\u0435" })), _jsx("div", { children: placeSlotsGetSate.isSuccess &&
                                        placeSlotsGetSate.data.days.length && (_jsx(GridSlots, { day: placeSlotsGetSate.data.days[0], placeId: placeId[0], onClick: timeChangeHandler, gameId: props.data.id })) }), _jsx(Flex, { gap: 4, style: { marginTop: 16 }, children: _jsx(Button, { view: "action", type: "submit", disabled: !isStep1Valid() || updateGameState.isLoading || isReserving, loading: updateGameState.isLoading || isReserving, children: "\u0414\u0430\u043B\u0435\u0435" }) })] }) }) }))] }) }));
};
